export const androidVersionCompatiableWithSymptomQuestionnaires = '3.0.6.1';
export const iOSVersionCompatiableWithSymptomQuestionnaires = '2.0.5';
